import classNames from "classnames"

type SectionProps = {
  title: string
  items: string[]
  className?: string
}

export function Section({ title, items, className }: SectionProps) {
  return (
    <section className={classNames("space-y-3", className)}>
      <h2 className="text-lg font-semibold">{title}</h2>
      <ul className="list-disc pl-6 space-y-1.5 text-sm leading-6 text-muted-foreground">
        {items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </section>
  )
}
